import { render, staticRenderFns } from "./util.vue?vue&type=template&id=964445f4&"
import script from "./util.vue?vue&type=script&lang=js&"
export * from "./util.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports